export default __webpack_public_path__ + "_/images/beer/beer-background-4fe1e12b6c82bd99b9b208e142f5c80abd6f0be115909b51157f6df05cd912a4.png";